import axios from "axios";
import Otp from "../component/Otp";
import { useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useErrValidate } from "../utilitis/AuthorizationPage";

function MainComp() {
  const [phone, setPhone] = useState(null);
  const [userData, setUserData] = useState();
  const { encode } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await axios.get(
          `/otp/getPassword/${encode}`,
          { withCredentials: true }
          // {
          //   headers: {
          //     Authorization:
          //       "Basic RjlBMTE3OTZGMjEyMDEwMTQ5OTg5NEJBN0E4MzE1QzQ3MUM1MTQ3NTA6TkVP",C
          //   },
          // }
        );
        let response_data = response.data;
        if (response_data.msg == "user is already sign in") {
          navigate("/openinvoice");
        }
        setPhone(response_data["Identify"]);
        setUserData(response_data);
        localStorage.setItem("encodeUrl", encode);
      } catch (error) {
        if (error.response.status == 403) {
          navigate("/");
        }
      }
    }
    if (phone == null) {
      fetchData();
    }
  }, [phone]);

  return (
    <>
      <Otp userData={userData} source={"linkopeninvoice"} />
      <Grid container alignItems="center" justifyContent="center">
        <Grid item>
          <Button
            variant="text"
            onClick={() => setPhone(null)}
            alt="ButtonToSendCodeAgain"
          >
            לשלוח קוד מחדש
          </Button>
        </Grid>
      </Grid>
    </>
  );
}

export default MainComp;
